export abstract class EtiquetaContent {
    abstract obtenerNombre(): string;
}
